<div class="header" mat-dialog-title>
  <strong>
    {{ 'findContent.openInAppNow' | translate }}
  </strong>
</div>

<button class="close-button" mat-icon-button (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <div class="download">
    {{ 'findContent.downloadApp' | translate }}
  </div>
  <div class="split">
    <div class="qr-and-pin">
      <qr-code-preview [qr]="data.qrSVG" [canCopy]="false"></qr-code-preview>
      <div class="pin" (click)="copyPin()">
        <div class="input-container flex-row">
          <div class="pin-char">
            {{ editionPrefix }}
          </div>
          <span class="pin-char-hyphen"> - </span>
          @for (char of pinCode?.split(''); track $index) {
          <div class="pin-char">
            {{ char }}
          </div>
          }
        </div>
      </div>
    </div>
    <div class="benefits">
      <div>
        <strong>{{ 'findContent.benefits.title' | translate }}</strong>
        <ul>
          <li>
            <mat-icon>check</mat-icon
            >{{ 'findContent.benefits.optimizedForSmartphones' | translate }}
          </li>
          <li>
            <mat-icon>check</mat-icon
            >{{ 'findContent.benefits.withAnalytics' | translate }}
          </li>
          <li>
            <mat-icon>check</mat-icon
            >{{ 'findContent.benefits.offlineUse' | translate }}
          </li>
        </ul>
      </div>
      <div class="app-download">
        <div class="app-links m-top">
          @if (!isIOS()) {
          <a (click)="openLink(androidLink)" class="app-link">
            <img src="assets/images/play-store-badge.png" />
          </a>
          } @if (!isAndroid()) {
          <a (click)="openLink(iosLink)" class="app-link">
            <img src="assets/images/app-store-badge.png" />
          </a>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
